import { Callout, ControlGroup } from "@blueprintjs/core"
import StaticSelector from "components/Atoms/StaticSelector"
import StringInput from "components/Atoms/StringInput"
import DynamicSelector from "components/Molecules/DynamicSelector"
import { SKUS } from "graphql/selector.queries.gql"
import useAuth from "hooks/useAuth"
import React, { useState } from "react"
import CalloutButton from "./CalloutButton"
import TimeSlotSelector from "./TimeSlotSelector"

const TimeSlotForm = ({ onAdd, onRemove, timeSlots }) => {
  const [ats, changeAts] = useState(null)

  const me = useAuth()
  const perUnitList = me?.user?.currentDepartment?.defaultPerUnit
  return (
    <>
      {timeSlots
        .map(({ timeSlot, quantityUnit }, index) => {
          return (
            <Callout
              key={timeSlot.id ? timeSlot.id : `ts-${index}`}
              className="relative mb-3 pb-0"
            >
              <div className="flex justify-end">
                <CalloutButton
                  listLength={timeSlots.length}
                  disabled={ats && ats.length === timeSlots.length}
                  path="timeSlots"
                  index={index}
                  onRemove={onRemove}
                  onAdd={onAdd}
                  newObject={{
                    timeSlot: {},
                    quantityUnit: quantityUnit || {},
                  }}
                />
              </div>
              <div className="grid grid-cols-12 gap-4">
                <div className="col-span-4">
                  <TimeSlotSelector
                    index={index}
                    timeSlots={timeSlots}
                    timeSlot={timeSlot}
                    onCompleted={data => {
                      changeAts(data.allTimeSlots)
                    }}
                  />
                </div>
                <div className="col-span-8">
                  <ControlGroup>
                    <StringInput
                      type="number"
                      label="Booking Quantity"
                      path={`timeSlots.${index}.quantity`}
                      big={false}
                    />
                    {perUnitList?.length ? (
                      <StaticSelector
                        label="Unit Type"
                        items={perUnitList}
                        path={`timeSlots.${index}.quantityUnit`}
                        big={false}
                      />
                    ) : (
                      <DynamicSelector
                        big={false}
                        label="Unit Type"
                        query={SKUS}
                        path={`timeSlots.${index}.quantityUnit`}
                        variables={{
                          filter: {
                            metadata_Labels_Contains: ["vesatogo"],
                          },
                        }}
                      />
                    )}
                  </ControlGroup>
                </div>
              </div>
            </Callout>
          )
        })
        .reverse()}
    </>
  )
}

export default TimeSlotForm
